import { FC, useEffect, useMemo, useState } from 'react';

import { cn } from 'utils/helpers';
import { Button } from 'ui/components/common';
import { useNavigate, useParams } from 'react-router-dom';

import {
  CardContactAdditionalDetails,
  CardContactDetails,
  CardContactInfo,
} from '../components';
import { useGetAccountCard } from '../hooks';

const CardPublicWeb: FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data: accountCard, isLoading: accountCardIsLoading } =
    useGetAccountCard(id as string);
  const [saveContact, setSaveContact] = useState<boolean>(false);

  const isMobile = useMemo(
    () => /iPad|iPhone|iPod|android/i.test(navigator.userAgent),
    [],
  );

  useEffect(() => {
    if (saveContact) navigate('preview');
  }, [saveContact, navigate]);

  if (accountCardIsLoading || !accountCard) return null;

  return (
    <div
      className={cn(
        'card',
        'bg-fill-tertiary',
        'rounded-md',
        'overflow-hidden',
        'flex',
        'flex-col',
        'sm:max-w-[430px]',
        'min-w-[300px]',
        'w-full',
        'sm:h-auto',
        'h-screen',
        'sm:justify-start',
        'justify-between',
      )}
    >
      <div className="space-y-2">
        <CardContactInfo accountCard={accountCard} />
        <div className={cn('p-[23px]', 'space-y-6')}>
          <CardContactDetails accountCard={accountCard} />
          <CardContactAdditionalDetails accountCard={accountCard} />
        </div>
      </div>
      {isMobile ? (
        <div className="p-[23px]">
          <Button
            label="Save Contact"
            intent="primary"
            size="md"
            className="w-full"
            onClick={() => setSaveContact(true)}
          />
        </div>
      ) : (
        <div className="text-center space-y-2 bg-fill-secondary p-4">
          <div className="rounded-md overlfow-hidden">
            <img
              src={accountCard?.qrCodeUrl}
              alt="QR Code"
              className="w-[150px] h-[150px] m-auto shadow-md"
            />
          </div>
          <p className="text-xs text-content max-w-[200px] m-auto">
            Scan QR Code to save '
            <span className="italic font-semibold">
              {accountCard?.meta?.firstName}
            </span>
            ' to your Contacts
          </p>
        </div>
      )}
    </div>
  );
};

export default CardPublicWeb;
